import React from 'react';

import food from '../../utils/data';

import ProductListCard from '../../Components/ProductList/ProductListCard';
import BackButton from '../../Components/BackButton';
function ProductList({ label }) {
  return (
    <section className="mt-10 ">
      <div className="ml-5">
        <BackButton />
      </div>
      <div className="lg:px-[50px] px-[15px] py-[25px] ">
        <p className="text-dark-2 lg:text-h1 text-h2 font-semibold py-[25px]">
          {label}
        </p>

        <div className="flex justify-between   flex-wrap space-x-[10px]">
          {food &&
            food.map((data) => (
              <ProductListCard
                food={data}
                id={data.id}
                key={data.id}
                foodName={data.foodName}
                restaurantName={data.restaurantName}
                src={data.src}
                waitingTime={data.waitingTime}
                calories={data.calories}
                tags={data.tags}
                price={data.price}
                rating={data.rating}
              />
            ))}
        </div>
      </div>
    </section>
  );
}

export default ProductList;
